import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotListedLocationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"not_listed_location"}/>
}
